import React, { useEffect } from "react";
import "./RetailCustomerPage.css";
import { AldiMark, CUSTOMER_TOKEN, useKodlyLoader } from "./retailDemo";

// Customer assistant of the retail demo, on a page of our own in ALDI's look (not a copy
// of aldi.pt), with the widget floating as it would on their site or in their app.
const IDEAS = [
  {
    title: "Planear as compras",
    text: "Um jantar para quatro com as promoções desta semana, com o preço de cada produto e o total.",
  },
  {
    title: "Oportunidades",
    text: "O que entra hoje, amanhã e na próxima semana, com os dias e as regras de cada promoção.",
  },
  {
    title: "Lojas e horários",
    text: "A loja mais perto, o horário de hoje e dos feriados, e onde ainda há um artigo.",
  },
  {
    title: "Trocas e garantia",
    text: "Prazos, talão, o que se pode devolver e o que fazer quando um artigo avaria.",
  },
];

function RetailCustomerPage() {
  useEffect(() => {
    document.title = "Assistente ALDI · Demonstração";
  }, []);
  useKodlyLoader(CUSTOMER_TOKEN);

  return (
    <div className="rcu-page">
      <header className="rcu-header">
        <AldiMark className="rcu-mark" />
        <span className="rcu-audience">Demonstração Kodly para ALDI Portugal</span>
      </header>
      <main className="rcu-main">
        <section className="rcu-hero">
          <p className="rcu-eyebrow">Assistente virtual</p>
          <h1>Custa pouco perguntar. No site e na app.</h1>
          <p className="rcu-lead">
            Conhece os produtos e os preços de aldi.pt, as Oportunidades de cada dia e as 166 lojas com os seus
            horários. Responde por escrito a quem escreve ou manda uma mensagem de voz.
          </p>
          <p className="rcu-try">Experimenta no botão em baixo, à direita.</p>
        </section>
        <section className="rcu-ideas">
          {IDEAS.map((idea) => (
            <article key={idea.title} className="rcu-idea">
              <h2>{idea.title}</h2>
              <p>{idea.text}</p>
            </article>
          ))}
        </section>
      </main>
      <footer className="rcu-footer">
        Demonstração Kodly com dados públicos de aldi.pt. Stock simulado.
      </footer>
    </div>
  );
}

export default RetailCustomerPage;
